import React from 'react';

import ThreePsEditor from '../components/three-ps/editor';

class ThreePsEditorPage extends React.Component {

    render() {
        return (
            <ThreePsEditor />
        )
    }

}

export default ThreePsEditorPage;


// WEBPACK FOOTER //
// ./src/containers/three-ps-editor-page.js